import styles from './MaxPromotionUsage.module.scss';
import MaxPromotionUsageNotification from './MaxPromotionUsageNotification';

interface MaxPromotionUsageProps {
    text: string;
    withNotification?: boolean;
}

const MaxPromotionUsage = (props: MaxPromotionUsageProps) => {
    if (props.withNotification) {
        return <MaxPromotionUsageNotification text={props.text} />;
    }

    return <span className={styles.Text}>Max {props.text}/hushåll</span>;
};

export default MaxPromotionUsage;
